import * as S from './FiltersDrawer.styles';

type Props = {
  dataTestId?: string;
  title: string;
  value: boolean | undefined;
  options: {
    dataTestId?: string;
    label: string;
    value: boolean | undefined;
  }[];
  onChange: (value: boolean | undefined) => void;
};

export const BooleanChips = ({
  dataTestId,
  title,
  value,
  options,
  onChange,
}: Props) => (
  <S.FieldWithTitleWrapper data-testid={dataTestId}>
    <S.FieldTitle>{title}</S.FieldTitle>
    <S.ChipsContainer>
      {options.map(
        ({ dataTestId: optionDataTestId, label, value: optionValue }) => {
          const isSelected = optionValue === value;
          return (
            <S.Chip
              key={label}
              dataTestId={optionDataTestId}
              appearance={isSelected ? 'primary' : 'gray'}
              isRounded
              onClick={() => onChange(optionValue)}
            >
              {label}
            </S.Chip>
          );
        }
      )}
    </S.ChipsContainer>
  </S.FieldWithTitleWrapper>
);
